package api

import kotlinx.serialization.Serializable

@Serializable
data class Phone(val number: String, val resend: Boolean = false)
